// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"d451799a","418":"e86765f2"}[chunkId] + ".chunk.js";
};